import styled from 'styled-components'

export const LocationAddModalWrapper = styled.div``



// WEBPACK FOOTER //
// ./src/Components/City/Page/Locations/Modals/LocationAddModalWrapper/index.js